(function() { module.exports = window["window"]; }());